import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { components } from '@doltech/dto';
import { TestStatusEnum, TestTypeEnum } from '@doltech/utils/lib/constants';

export const fetchUserTests = async (
  testType: TestTypeEnum = TestTypeEnum.FULL_TEST,
  testIds = [],
  sectionIds = [],
  statuses = [TestStatusEnum.IN_PROGRESS]
) => {
  const { data } = await apis.onlineTest.get<components['schemas']['PageUserTestOverviewDTO']>(
    apiUrls.onlineTest.USER_TEST_INPROGRESS,
    {
      status: statuses,
      page: 0,
      testType,
      testIds,
      sectionIds,
    }
  );

  return data;
};

export const fetchLatestUserTests = async (
  testType: TestTypeEnum = TestTypeEnum.FULL_TEST,
  testIds = [],
  sectionIds = [],
  trialUserId
) => {
  const { data } = await apis.onlineTest.get<components['schemas']['PageUserTestOverviewDTO']>(
    apiUrls.onlineTest.USER_TEST_INPROGRESS,
    {
      status: [TestStatusEnum.IN_PROGRESS],
      trialUserId,
      page: 0,
      testType,
      testIds,
      sectionIds,
      size: 1,
      sort: 'createdAt,desc',
    }
  );

  return data;
};
